import { render, staticRenderFns } from "./RmaProductsSizeSelector.vue?vue&type=template&id=4d54ce3a&"
import script from "./RmaProductsSizeSelector.vue?vue&type=script&lang=js&"
export * from "./RmaProductsSizeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports